import React from "react";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import DatePicker from "../../../../components/DatePicker";

const pad = (n) => String(n).padStart(2, "0");

const CalendarNavigation = ({
  currentDate,
  monthNames,
  eventCount = 0,
  styles,
  screenSize,
  language,
  theme,
  t,
  handlePrevMonth,
  handleNextMonth,
  handleGoToToday,
  onSelectMonth,
}) => {
  const isRTL = language === "ar";
  const monthValue = `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(
    currentDate.getDate()
  )}`;

  // In RTL the timeline runs right-to-left, so "previous" points right.
  const PrevIcon = isRTL ? ChevronRight : ChevronLeft;
  const NextIcon = isRTL ? ChevronLeft : ChevronRight;
  const iconSize = screenSize.isMobile ? 18 : 20;

  return (
    <div style={styles.calendarHeader}>
      {/* Month + year, with the count of this month's events as a quiet
          subtitle instead of yet another stat card. */}
      <div style={{ minWidth: 0 }}>
        <h2 style={styles.currentMonth}>
          {monthNames[currentDate.getMonth()]}
          <span style={styles.currentYear}>{currentDate.getFullYear()}</span>
        </h2>
        {eventCount > 0 && (
          <div
            style={{
              fontSize: screenSize.isMobile ? "11.5px" : "12.5px",
              fontWeight: 600,
              color: styles.tokens.textMuted,
              marginTop: "4px",
            }}
          >
            {eventCount} {eventCount === 1 ? t.event : t.events}
          </div>
        )}
      </div>

      <div style={styles.calendarNavigation}>
        <button
          type="button"
          className="cal-nav-btn"
          style={styles.navButton}
          onClick={handlePrevMonth}
          aria-label={isRTL ? "الشهر السابق" : "Previous month"}
        >
          <PrevIcon size={iconSize} />
        </button>

        <button
          type="button"
          className="cal-nav-btn"
          style={styles.todayButton}
          onClick={handleGoToToday}
        >
          <CalendarDays size={screenSize.isMobile ? 14 : 15} />
          {t.today}
        </button>

        <button
          type="button"
          className="cal-nav-btn"
          style={styles.navButton}
          onClick={handleNextMonth}
          aria-label={isRTL ? "الشهر التالي" : "Next month"}
        >
          <NextIcon size={iconSize} />
        </button>

        <div style={{ width: screenSize.isMobile ? "100%" : "190px", minWidth: 0 }}>
          <DatePicker
            theme={theme}
            isRTL={isRTL}
            value={monthValue}
            onChange={(dateStr) => onSelectMonth?.(new Date(`${dateStr}T00:00:00`))}
            placeholder={`${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarNavigation;
